export const questions = [
    {question: 'How do WhistleBlower work ?', answer: 'Our platform analyzes your energy usage data to identify areas for improvement and offers actionable insights for increased sustainability.'},
    {question: 'How to contact us ?', answer: 'You can reach out to us via e-mail, phone, or by filling out the contact form on our website. We are here to answer any questions you may have.'},
    {question: 'About our confidentiality', answer: 'We prioritize your privacy and ensure that all data is kept confidential and secure according to industry standards.'},
    {question: 'Why would you choose us ?', answer: 'We bring expertise and a passion for sustainability to help your business succeed while reducing environmental impact.'},
    {question: 'Will we help you to increase your income ?', answer: 'By optimizing your energy consumption, we help reduce operational costs, which can lead to improved profitability.'},
  ];

  export const data = {
    region: "FR",
    consommations: {
      1: 123,
      2: 189,
      3: 250,
      4: 204,
      5: 200,
      6: 58,
      7: 90,
      8: 270,
      9: 100,
      10: 200,
      11: 123,
      12: 253,
    },
    emissions: {
      1: 5.011,
      2: 7.701,
      3: 10.19,
      4: 8.312,
      5: 8.149,
      6: 2.363,
      7: 3.667,
      8: 11,
      9: 4.074,
      10: 8.149,
      11: 5.011,
      12: 10.31,
    },
    annee: 2024,
  };